import script from "./UserList.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserList.vue?vue&type=script&lang=ts&setup=true"

import "./UserList.vue?vue&type=style&index=0&id=66f6d2cc&lang=scss&scoped=true"

import exportComponent from "/Users/BlackPaw/Developer/acebed_vue3_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66f6d2cc"]])

export default __exports__